import { Image } from '@skytech/ui/Image'
import { useDispatch, connect } from 'react-redux'

import { useAppContext } from '@/App.context'
import { Translation } from '@/components/i18n/Translation'
import { STEP_CONFIRM } from '@/ducks/onboarding/constants'
import {
  decreaseStep,
  goToStep,
  increaseStep,
  increaseStepBy,
  selectMachine,
  selectMachineImage,
} from '@/ducks/onboarding/onboardingActions'
import {
  getImages,
  getMachines,
  getOnboardingSelectedImageId,
  getOnboardingSelectedMachineId,
  getWorkType,
} from '@/ducks/onboarding/onboardingSelectors'
import { useIsMultiConsult } from '@/hooks/user'
import { numberFormat } from '@/util/formatters/numbers'

import './step-software.scss'

const StepMachine = ({
  machines,
  images,
  selectedMachineId,
  selectMachineImage,
  selectedImageId,
}: any) => {
  const dispatch = useDispatch()
  const { whiteLabel } = useAppContext()
  const isMultiConsult = useIsMultiConsult()

  return (
    <div id="step-software" className="step">
      {selectedMachineId && !selectedImageId && (
        <>
          <div className="info">
            <h2 className={whiteLabel}>
              <Translation id="PC Modell er valgt" />
            </h2>

            <p>
              <Translation id="Din PC vil leveres med ferdig installert programvare tilpasset ditt bruk." />
            </p>

            <p>
              <Translation id={`Velg hvilke type arbeid denne PC'en skal benyttes til.`} />
            </p>
          </div>

          <SelectProduct
            products={
              isMultiConsult
                ? // @ts-ignore
                  images.filter(image => image.name === 'UTEN FAGAPPLIKASJONER')
                : images
            }
            // @ts-ignore
            selectAction={arg => selectMachineImage(arg)}
            isImage={true}
          />

          <div className="navigation">
            <button onClick={() => dispatch(decreaseStep())} className={whiteLabel}>
              <Translation id="Tilbake" />
            </button>
          </div>
        </>
      )}

      {selectedMachineId && selectedImageId && (
        <>
          <h2 className={whiteLabel}>
            <Translation id="PC Modell og programvare er valgt" />
          </h2>

          <ProductSummary
            // @ts-ignore
            {...machines.find(machine => machine.id === selectedMachineId)}
            onClick={() => dispatch(decreaseStep())}
          />

          <ProductSummary
            // @ts-ignore
            {...images.find(image => image.id === selectedImageId)}
            isImage={true}
            onClick={() => selectMachineImage()}
          />

          <div className="navigation">
            <button onClick={() => dispatch(increaseStep())} className={whiteLabel}>
              <Translation id="Velg tilbehør" />
            </button>

            <button onClick={() => dispatch(goToStep(STEP_CONFIRM))} className={whiteLabel}>
              <Translation id="Jeg ønsker ikke tilbehør" />
            </button>
          </div>
        </>
      )}
    </div>
  )
}

const SelectProduct = ({ products, selectAction, isImage = false }: any) =>
  products.map(({ id, ...restOfProps }: any) => (
    // @ts-ignore
    <Product key={id} isImage={isImage} onClick={() => selectAction(id)} {...restOfProps} />
  ))

const Product = ({
  name,
  productName,
  description,
  usageDescription,
  specs,
  imgUrl,
  price,
  onClick,
  isImage,
}: any) => {
  const { whiteLabel } = useAppContext()

  return (
    <div className="product">
      <div className="product__image">{imgUrl && <Image src={imgUrl} alt="product" />}</div>

      <div className="product__description">
        <h2 className={whiteLabel}>{name}</h2>

        {!isImage && <h3>{productName}</h3>}

        <h4>{specs}</h4>
        <p>{description}</p>
        <p>{usageDescription}</p>

        {!isImage && (
          <h4>
            <Translation id="Pris: {price}" values={{ price: <b>{numberFormat(price)},-</b> }} />
          </h4>
        )}

        <button onClick={onClick} className={whiteLabel}>
          <Translation id="Velg denne" />
        </button>
      </div>
    </div>
  )
}

const ProductSummary = ({ name, description, usageDescription, imgUrl, onClick }: any) => {
  const { whiteLabel } = useAppContext()

  return (
    <div className="product-summary">
      <div className="image">
        <Image src={imgUrl} alt="product" />
      </div>

      <div className="text">
        <h3>{name}</h3>
        <p>{usageDescription}</p>
        <p>{!usageDescription && description}</p>

        <button onClick={onClick} className={whiteLabel}>
          <Translation id="Endre" />
        </button>
      </div>
    </div>
  )
}

// @ts-ignore
const mapStateToProps = state => ({
  selectedMachineId: getOnboardingSelectedMachineId(state),
  selectedImageId: getOnboardingSelectedImageId(state),
  machines: getMachines(state),
  images: getImages(state),
  workType: getWorkType(state),
})

const mapDispatchToProps = {
  selectMachine,
  selectMachineImage,
  increaseStep,
  increaseStepBy,
}

export default connect(mapStateToProps, mapDispatchToProps)(StepMachine)
